import { useApi } from '@/@diffrag/hooks/useApi'
import { ContentView } from '@/@diffrag/layout/ContentView'
import { SimpleTable } from '@/@diffrag/table/SimpleTable'
import { api } from '@/api'
import { IFooterIconRO } from 'api'

export default function FooterIcon() {
  const { data, isFetching, refetch } = useApi({
    id: 'footerIconList',
    fn: api().adminFooterIcon.adminFooterIconList,
  })

  const onDelete = async (rows: IFooterIconRO[]) => {
    try {
      await Promise.all(
        rows.map((row) => api().adminFooterIcon.adminFooterIconDelete(row.id)),
      )
      refetch()
    } catch (error) {
      console.error(error)
      alert('삭제 중 오류가 발생했습니다.')
    }
  }

  return (
    <ContentView>
      <SimpleTable
        createHref="/footer/edit"
        totalCount={data?.total || 0}
        onDelete={onDelete}
        columns={[
          {
            label: 'ID',
            key: 'id',
            width: 100,
            isPrimary: true,
            href: (row) => `/footer/edit?id=${row.id}`,
          },
          {
            label: '순서',
            key: 'order',
            width: 100,
          },
          {
            label: '위치',
            key: 'side',
            width: 100,
            formatter: (value) => {
              return value === 'left' ? '왼쪽' : '오른쪽'
            },
          },
          {
            label: '아이콘',
            key: 'icon.path',
            width: 200,
            formatter: (value) => {
              if (!value) return '-'
              return (
                <img
                  src={value}
                  alt="footer icon"
                  className="size-8 object-cover"
                />
              )
            },
          },
          {
            label: '한국어 링크',
            key: 'krLink',
            width: 200,
            formatter: (value) => value || '-',
          },
          {
            label: '영어 링크',
            key: 'enLink',
            width: 200,
            formatter: (value) => value || '-',
          },
          {
            label: '중국어 링크',
            key: 'zhLink',
            width: 200,
            formatter: (value) => value || '-',
          },
          {
            label: '일본어 링크',
            key: 'jpLink',
            width: 200,
            formatter: (value) => value || '-',
          },
          {
            label: '태국어 링크',
            key: 'thLink',
            width: 200,
            formatter: (value) => value || '-',
          },
        ]}
        data={data?.items || []}
        isLoading={isFetching}
        options={{
          disableSort: true,
          disableSearch: true,
        }}
      />
    </ContentView>
  )
}
